import Transition from "transitions/transition";

export function Pop(props) {
  const { children } = props;

  return (
    <Transition transition="pop" {...props}>
      {children}
    </Transition>
  );
}
